import React, { useState } from "react";
import styled, { css } from "styled-components";
import { withTranslation, WithTranslation } from "react-i18next";
import { PageRendererProps } from "gatsby";
import { Element } from "react-scroll";

import Layout from "src/components/Layout";
import { colors } from "src/styles/colors";
import Header from "src/components/Header";
import Footer from "src/components/Footer";
import ServiceSection from "src/components/section/Home/ServiceSection";
import PartnerSection from "src/components/section/Home/PartnerSection";
import UsecasesSection from "src/components/section/Home/UsecasesSection";
import OneStopSection from "src/components/section/Home/OneStopSection";
import SecuritySection from "src/components/section/Home/SecuritySection";
import DashboardSection from "src/components/section/Home/DashboardSection";
import ApiSection from "src/components/section/Home/ApiSection";
import TryItSection from "src/components/section/Home/TryItSection";
import { media } from "src/utils/media";
import SaveGasFeesSection from "src/components/section/Home/SaveGasFeesSection";
import CustomerSection from "src/components/section/Home/CustomerSection";

type Props = { isKo: boolean };

const Container = styled(Layout)`
  background-color: ${colors.bg.white.main};
`;

const HeaderView = styled(Header)``;

const Content = styled.div<{ $isKo: boolean }>`
  background-color: ${colors.bg.white.main};
  ${({ $isKo }) =>
    $isKo
      ? css`
          padding-top: calc(52px);
        `
      : css``}
`;

const IndexPage = (props: Props) => {
  const { isKo } = props;

  return (
    <React.Fragment>
      <Container id="outer-container">
        <HeaderView isKo={isKo} />
        <Content $isKo={isKo} id="page-box">
          <ServiceSection />
          <PartnerSection />
          <OneStopSection />
          <UsecasesSection isKo={isKo} />
          <SecuritySection />
          <SaveGasFeesSection />
          <DashboardSection />
          <ApiSection />
          <CustomerSection />
          <TryItSection />
          <Footer />
        </Content>
      </Container>
    </React.Fragment>
  );
};

export default IndexPage;
